import type { ProjectGalleryItem } from '../types/gallery';

export const galleryItems: ProjectGalleryItem[] = [
    {
      id: 1,
      title: "Ventana de Aluminio Residencial",
      category: "Ventanas",
      imageAlt: "Ventana de aluminio color blanco instalada en residencia, con diseño moderno y funcional",
      imageUrl: "/images/ventana-1.webp",
      images: ["/images/ventana-1.webp", "/images/ventana-3.webp"],
      description: "Ventana de aluminio de alta calidad instalada en proyecto residencial. Diseño moderno con excelente aislamiento térmico y acústico.",
      details: [
        "Aluminio de alta resistencia con acabado en pintura electrostática",
        "Vidrio flotado de 6mm con excelente aislamiento térmico",
        "Herrajes de acero inoxidable para mayor durabilidad",
        "Sistema de drenaje integrado para evitar filtraciones",
        "Garantía de 5 años en estructura y herrajes"
      ]
    },
    {
      id: 2,
      title: "Ventana Panorámica",
      category: "Ventanas",
      imageAlt: "Ventana panorámica de aluminio con vista amplia, ideal para espacios modernos",
      imageUrl: "/images/ventana-3.webp",
      images: ["/images/ventana-3.webp", "/images/ventana-6.webp"],
      description: "Ventana panorámica que maximiza la entrada de luz natural y ofrece vistas espectaculares. Perfecta para espacios modernos y amplios.",
      details: [
        "Diseño panorámico para máxima visibilidad",
        "Perfil de aluminio reforzado para grandes dimensiones",
        "Vidrio de seguridad laminado",
        "Sellado hermético contra agua y aire",
        "Manijas ergonómicas de fácil operación"
      ]
    },
    {
      id: 3,
      title: "Ventana con Marco Reforzado",
      category: "Ventanas",
      imageAlt: "Ventana de aluminio con marco resistente y acabado profesional",
      imageUrl: "/images/ventana-6.webp",
      description: "Ventana con marco de aluminio reforzado, ideal para condiciones climáticas adversas. Acabado profesional que garantiza durabilidad.",
      details: [
        "Marco de aluminio extruido de alta resistencia",
        "Tratamiento anticorrosivo para mayor vida útil",
        "Vidrio templado de 8mm para mayor seguridad",
        "Juntas de EPDM para sellado perfecto",
        "Instalación profesional incluida"
      ]
    },
    {
      id: 4,
      title: "Cancel de Baño Premium",
      category: "Canceles",
      imageAlt: "Cancel de baño de vidrio templado con herrajes cromados y diseño elegante",
      imageUrl: "/images/cancel-1.webp",
      description: "Cancel de baño de lujo con vidrio templado y herrajes de primera calidad. Diseño elegante que transforma completamente el espacio.",
      details: [
        "Vidrio templado de 10mm con tratamiento antical",
        "Herrajes cromados de importación europea",
        "Rieles de aluminio con rodamientos de precisión",
        "Sellos magnéticos para cierre hermético",
        "Instalación profesional y nivelación perfecta"
      ]
    },
    {
      id: 5,
      title: "Puerta Residencial Moderna",
      category: "Puertas",
      imageAlt: "Puerta residencial de aluminio con acabado moderno y seguro",
      imageUrl: "/images/puerta-5.webp",
      images: ["/images/puerta-5.webp", "/images/puerta-22.webp"],
      description: "Puerta residencial de diseño contemporáneo con alta seguridad. Combina estética moderna con funcionalidad superior.",
      details: [
        "Estructura de aluminio con núcleo reforzado",
        "Cerradura de seguridad multipunto",
        "Pintura electrostática en color personalizado",
        "Bisagras ocultas de alta resistencia",
        "Umbral con sistema de drenaje integrado"
      ]
    },
    {
      id: 6,
      title: "Puerta de Entrada Principal",
      category: "Puertas",
      imageAlt: "Puerta de entrada principal de aluminio con diseño contemporáneo y alta seguridad",
      imageUrl: "/images/puerta-22.webp",
      description: "Puerta principal de máxima seguridad con diseño arquitectónico único. Perfecta para residencias de alto nivel.",
      details: [
        "Diseño arquitectónico exclusivo",
        "Sistema de seguridad de grado comercial",
        "Acabados premium en aluminio anodizado",
        "Vidrio de seguridad con películas especiales",
        "Garantía extendida de 10 años"
      ]
    },
    {
      id: 7,
      title: "Vitrina Comercial Profesional",
      category: "Vitrinas",
      imageAlt: "Vitrina comercial de aluminio y vidrio para exhibición de productos en negocios",
      imageUrl: "/images/vitrina-2.webp",
      description: "Vitrina comercial diseñada para maximizar la exhibición de productos. Construcción robusta ideal para uso comercial intensivo.",
      details: [
        "Estructura modular adaptable a diferentes espacios",
        "Vidrio cristal float para máxima claridad",
        "Iluminación LED integrada opcional",
        "Cerraduras de seguridad en todos los accesos",
        "Mantenimiento mínimo requerido"
      ]
    }
];
